module.exports = __webpack_public_path__ + "static/google-play-badge-fr-f46c975698ebe5e0784499b1f900eb2f.png";